export type Severity = 'low' | 'medium' | 'high';

export const SEVERITY_LABELS: Record<Severity, string> = {
  low: 'Låg',
  medium: 'Medel',
  high: 'Hög',
};

export const SEVERITY_COLORS: Record<Severity, string> = {
  low: 'border-blue-300 text-blue-700 bg-blue-50',
  medium: 'border-amber-300 text-amber-700 bg-amber-50',
  high: 'border-red-300 text-red-700 bg-red-50',
};
